import { useMemo } from 'preact/hooks';
import { WorkCard as UiWorkCard } from '../primitives';
import { useRelativeTime } from '../i18n';
import type { WorkSummary } from '../api/types';
import { toCardModel } from './toCardModel';
import { useWorkLike } from '../hooks/useMyLikes';
import { isAdmin, useMe } from '../auth/useMe';
import { workUrl, withBase } from '../paths';

/**
 * Catalog card. Delegates rendering to the platform's cover-forward `<WorkCard>` primitive;
 * The server supplies like and ownership markers. Like toggles persist through `useWorkLike`;
 * the authenticated viewer's admin role controls the lifecycle border.
 */
export function WorkCard({ pkg }: { pkg: WorkSummary }) {
    const rel = useRelativeTime();
    const me = useMe();
    const { liked, setLiked, signedIn } = useWorkLike(pkg.id, pkg.likedByMe ?? false);
    const viewerIsAdmin = me.status === 'authenticated' && isAdmin(me.user);

    const model = useMemo(
        () => toCardModel(pkg, {
            formatRelative: rel,
            viewerIsAdmin,
        }),
        [pkg, rel, viewerIsAdmin],
    );

    return (
        <a href={withBase(workUrl(pkg))} class="block">
            <UiWorkCard
                pkg={model}
                signedIn={signedIn}
                liked={liked}
                onLikeChange={(_id, next) => {
                    void setLiked(next);
                }}
            />
        </a>
    );
}
